import { MaterialType } from "../ResourceElements/MaterialType";
import { Collection } from "./Collection";
import { StructureCollection } from "./StructureCollection";

export class RepairCampaign extends StructureCollection {

    public get IsFinished(): boolean {
        return this.CollectionInfoModel.IsFinished;
    }
    public set IsFinished(v: boolean) {
        this.CollectionInfoModel.IsFinished = v;
    }

    private _loaded: boolean;
    public get loaded(): boolean {
        return this._loaded;
    }
    public set loaded(v: boolean) {
        this._loaded = v;
    }

    constructor(collectionInfoModel: any, date: Date) {
        super(date);
        this.CollectionInfoModel = collectionInfoModel;
        this.Type = 'RepairCampaign';
        this.Guid = collectionInfoModel.CollectionId;

        this.CollectionInfoModel.InspectionTypeId = this.CollectionInfoModel.InspectionTypeId ?? this.CollectionInfoModel.CurrentInspectionTypeId;
    }

    public get regionId(): string {
        return this.CollectionInfoModel.RegionId ?? this.CollectionInfoModel.BlobPaths[0]?.RegionId;
    }
    public set regionId(v: string) {
        this.CollectionInfoModel.RegionId = v;
    }

}